export function getTargetTypeMsg(type) {
	// targetType (all, in-zone, all-any-in-zone)
	switch (type) {
		case 'all':
			return 'Everyone that meets these criteria';
		case 'in-zone':
			return 'Contacts in specific zones';
		case 'all-any-in-zone':
			return 'All contacts when any contact is in notification zone';
		default:
			return '- -';
	}
}

export const optionsWho = [
	{ value: 'all', label: 'Everyone that meets these criteria' },
	{ value: 'in-zone', label: 'Contacts in specific zones' },
	{
		value: 'all-any-in-zone',
		label: 'All contacts when any contact is in notification zone',
	},
];
export const optionsWhoCore = [
	// { /*value: 'all', label: 'Everyone that meets these criteria' */},
	{ value: 'in-zone', label: 'Contacts in specific zones' },
];

export function getActionTypeMsg(type) {
	// actionType(evac-start, evac-end)
	switch (type) {
		case 'evac-start':
			return 'From the start of an evacuation';
		case 'evac-end':
			return 'At the end of an Evacuation';
		case 'upon-detection':
			return 'Upon detection';
		default:
			return '- -';
	}
}

export const optionsWhen = [
	{ value: 'evac-start', label: 'From the start of an evacuation' },
	{ value: 'evac-end', label: 'At the end of an Evacuation' },
];

export const optionsWhenCore = [
	{ value: 'upon-detection', label: 'Upon detection' },
];

export const optionsFrequency = [
	{ value: 0, label: 'Once per evacuation' },
	{ value: 1, label: 'Every minute' },
	{ value: 2, label: 'Every 2 minutes' },
	{ value: 3, label: 'Every 3 minutes' },
	{ value: 5, label: 'Every 5 minutes' },
	{ value: 10, label: 'Every 10 minutes' },
	{ value: 15, label: 'Every 15 minutes' },
];

export const optionsFrequencyCore = [
	{ value: 0, label: 'Never' },
	{ value: 1440, label: 'Once a day' },
	{ value: 1, label: 'Every minute' },
	{ value: 2, label: 'Every 2 minutes' },
	{ value: 3, label: 'Every 3 minutes' },
	{ value: 5, label: 'Every 5 minutes' },
	{ value: 10, label: 'Every 10 minutes' },
	{ value: 15, label: 'Every 15 minutes' },
];

export const optionsMsgType = [
	{ value: 'sms', label: 'SMS' },
	{ value: 'email', label: 'Email' },
];
export const optionsDistributionType = [
	// { /*value: 'all', label: 'Everyone that meets these criteria' */},
	{ value: 'specific-holders', label: 'Selected contacts only' },
];



// WEBPACK FOOTER //
// ./src/pages/notifications/helper.js